<template>
  <div
    class="diy-window"
    :style="'background:'+itemStyle.background+'; padding:'+itemStyle.paddingTop+'px '+itemStyle.paddingLeft+'px;'"
  >
    <!-- matrix -->
    <div v-if="itemStyle.layout > -1" :class="'data-list avg-sm-'+itemStyle.layout">
      <div
        v-for="(dataItem,index) in datalist"
        :key="index"
        class="data-item"
        :style="'padding:'+itemStyle.paddingTop +'px '+itemStyle.paddingLeft +'px;'"
      >
        <div class="item-img" @click="navigationTo()" :data-url="dataItem.linkUrl">
          <img style="width:100%" :src="dataItem.imgUrl">
        </div>
      </div>
    </div>
    <!-- display -->
    <div v-if="itemStyle.layout <= -1" class="display">
      <!-- 1 -->
      <div
        class="display-left"
        :style="'padding:'+itemStyle.paddingTop +'px'+ itemStyle.paddingLeft +'px;'"
      >
        <img @click="navigationTo()" :data-url="dataList[0].linkUrl" :src="dataList[0].imgUrl">
      </div>
      <!-- 2 -->
      <div
        v-if="dataList.length === 2"
        class="display-right"
        :style="'padding:'+itemStyle.paddingTop +'px'+ itemStyle.paddingLeft +'px'"
      >
        <img @click="navigationTo()" :data-url="dataList[1].linkUrl" :src="dataList[1].imgUrl">
      </div>
      <!-- 3 -->
      <div v-if="dataList.length === 3" class="display-right">
        <div
          class="display-right1"
          :style="'padding:'+itemStyle.paddingTop +'px'+ itemStyle.paddingLeft +'px;'"
        >
          <img @click="navigationTo()" :data-url="dataList[1].linkUrl" :src="dataList[1].imgUrl">
        </div>
        <div
          class="display-right2"
          :style="'padding:'+itemStyle.paddingTop +'px'+ itemStyle.paddingLeft +'px;'"
        >
          <img @click="navigationTo()" :data-url="dataList[2].linkUrl" :src="dataList[2].imgUrl">
        </div>
      </div>
      <!-- 4 -->
      <div v-if="dataList.length === 4" class="display-right">
        <div
          class="display-right1"
          :style="'padding:'+itemStyle.paddingTop +'px'+ itemStyle.paddingLeft +'px;'"
        >
          <img @click="navigationTo()" :data-url="dataList[1].linkUrl" :src="dataList[1].imgUrl">
        </div>
        <div class="display-right2">
          <div
            class="left"
            :style="'padding:'+itemStyle.paddingTop +'px'+ itemStyle.paddingLeft +'px;'"
          >
            <img @click="navigationTo()" :data-url="dataList[2].linkUrl" :src="dataList[2].imgUrl">
          </div>
          <div
            class="right"
            :style="'padding:'+ itemStyle.paddingTop +'px'+ itemStyle.paddingLeft +'px;'"
          >
            <img @click="navigationTo()" :data-url="dataList[3].linkUrl" :src="dataList[3].imgUrl">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params", "datalist"],
  created() {},
  activated() {},
  methods: {
      navigationTo(){
          
      }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
/* 图片橱窗 */

.diy-window .data-list::after {
  clear: both;
  content: " ";
  display: table;
}

.diy-window .data-list .data-item {
  float: left;
  box-sizing: border-box;
}

.diy-window .data-list img {
  display: block;
  width: 100%;
}

/* 分列布局 */

.diy-window .avg-sm-2 > .data-item {
  width: 50%;
}

.diy-window .avg-sm-3 > .data-item {
  width: 33.33333333%;
}

.diy-window .avg-sm-4 > .data-item {
  width: 25%;
}

.diy-window .avg-sm-5 > .data-item {
  width: 20%;
}

/* 橱窗样式 */

.diy-window .display {
  height: 0;
  width: 100%;
  margin: 0;
  padding-bottom: 50%;
  position: relative;
  box-sizing: border-box;
}

.diy-window .display div {
  box-sizing: border-box;
}

.diy-window .display img {
  width: 100%;
  height: 100%;
}

.diy-window .display .display-left {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.diy-window .display .display-right {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
}

.diy-window .display .display-right1 {
  width: 100%;
  height: 50%;
  position: absolute;
  top: 0;
  left: 0;
}

.diy-window .display .display-right2 {
  width: 100%;
  height: 50%;
  position: absolute;
  top: 50%;
  left: 0;
}

.diy-window .display .display-right2 .left {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.diy-window .display .display-right2 .right {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
}
</style>